import { Faqs } from '@grandstand-web/ui'
import { FaqsContainer } from './Packages.styles'

const PackagesFaq = () => {
  const faqs = [
    {
      heading: 'Is FanDuel Sports Network the new Bally Sports?',
      text: (
        <>
          Yes. We rebranded our service from Bally Sports and Bally Sports+ to FanDuel Sports Network in the Fall of
          2024. Everything else remains the same, we&apos;ve just got a cool new name, look and feel.
        </>
      ),
    },
    {
      heading: 'What is FanDuel Sports Network?',
      text: (
        <>
          FanDuel Sports Network (formerly known as Bally Sports) is a television company made up of a collection of
          Regional Sports Networks (aka &quot;RSNs&quot;) that provide live sports broadcasts of local teams and other
          sports content. Fans can watch with a streaming subscription or through a cable, satellite or streaming TV
          provider. Our RSNs are home to nearly half of all MLB, NHL, and NBA teams based in the US, meaning we produce
          thousands of local telecasts every year.
        </>
      ),
    },
    {
      heading: 'Which MLB teams are available to stream for the 2025 season?',
      text: (
        <>
          For the 2025 MLB Season, FanDuel Sports Network will broadcast the Atlanta Braves, Detroit Tigers, Kansas City
          Royals, Los Angeles Angels, Miami Marlins, Milwaukee Brewers, St. Louis Cardinals, Tampa Bay Rays, and
          Cincinnati Reds.
          <br />
          <br />
          *New* this season, ALL MLB teams are available to watch WITH A STREAMING package (sign up above) or with a TV
          provider.
        </>
      ),
    },
    {
      heading: 'How do I know if I live in a FanDuel Sports Network region?',
      text: (
        <>
          Visit{' '}
          <a style={{ textDecoration: 'underline' }} href="https://GetMyHomeTeams.com">
            GetMyHomeTeams.com
          </a>{' '}
          and enter your zip code to see if you have access to FanDuel Sports Network content.
        </>
      ),
    },
    {
      heading: 'How do I subscribe to FanDuel Sports Network?',
      text: (
        <ol className="list-decimal pl-7">
          <li>
            Scroll up to the top of this page and enter your zip code. The packages and teams available in your area
            will display.
          </li>
          <li>Select from a monthly plan, season pass (available 2/21/25 – 6/30/25) or annual plan.</li>
          <li>Click &quot;subscribe.&quot;</li>
          <li>Create a FanDuel Sports Network account.</li>
          <li>Follow the on-screen payment instructions.</li>
          <li>Once the payment is processed, you can start streaming your teams.</li>
        </ol>
      ),
    },
    {
      heading: 'What platforms can I stream on?',
      text: (
        <>
          FanDuel Sports Network programming can be streamed on the following:
          <br />
          <br />
          <ul className="list-disc pl-7">
            <li>FanDuelSportsNetwork.com</li>
            <li>iOS & Android Mobile & Tablet devices vis the FanDuel Sports Network app</li>
            <li>Samsung TV (2019 and newer models)</li>
            <li>Amazon Prime Video Channels</li>
            <li>Amazon Fire TV</li>
            <li>Android TV</li>
            <li>Apple TV</li>
            <li>Xbox One</li>
            <li>Xbox Series X/S</li>
            <li>Chromecast</li>
            <li>Comcast (X1, Xumo TV, Xumo Stream Box, Flex)</li>
          </ul>
        </>
      ),
    },
  ]

  return (
    <FaqsContainer>
      <Faqs faqs={faqs} />
    </FaqsContainer>
  )
}

export default PackagesFaq
